<template>
  <div class="acceptance-form">
    <tg-title>
      <span class="company-name">{{ companyName }}</span
      >, valide as principais mudanças na política do RD Station Conversas
    </tg-title>
    <ul>
      <li><tg-text>Atualização dos nossos Planos e Add-ons</tg-text></li>
      <li><tg-text>Atualização da Política de Pagamento</tg-text></li>
      <li><tg-text>Atualização das cláusulas de Proteção de Dados</tg-text></li>
    </ul>
    <div class="acceptance-checkbox">
      <input type="checkbox" id="accept-terms" v-model="termAccepted" />
      <label for="accept-terms"
        >Li e concordo com os
        <a href="https://legal.rdstation.com/pt/rdc-services-agreement/">Termos de Uso da plataforma</a> RD Station
        Conversas.</label
      >
    </div>
    <div class="acceptance-actions">
      <tg-button
        type="button"
        @click="accept"
        :loading="loading"
        :disabled="!termAccepted"
      >
        Aceitar os termos
      </tg-button>
    </div>
  </div>
</template>
<script>
import NewAcceptanceStatusMixin from "@/mixins/NewAcceptanceStatusMixin";
import TangramTitle from "@/components/Tangram/Title.vue";
import TangramText from "@/components/Tangram/Text.vue";
import TangramButton from "@/components/Tangram/Button.vue";

export default {
  name: "NewAcceptTermForm",

  mixins: [NewAcceptanceStatusMixin],

  components: {
    "tg-title": TangramTitle,
    "tg-text": TangramText,
    "tg-button": TangramButton,
  },

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    companyName: {
      type: String,
      default: "...",
    },
  },

  data() {
    return {
      termAccepted: false
    };
  },
  methods: {
    accept() {
      this.$emit("accepted", this.acceptanceSteps.ACCEPT);
    },
  },
};
</script>

<style scoped lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Red+Hat+Display:wght@400;600&display=swap");

:root {
  font-family: "Red Hat Display", sans-serif;
}

.company-name {
  color: #11a7b6;
}

.acceptance-form {
  width: 100%;
  height: auto;
  gap: 24px 0;
  padding-left: 72px;
  display: flex;
  flex-direction: column;

  .acceptance-checkbox {
    display: flex;
    align-items: center;
    gap: 12px;
    input[type="checkbox"] {
      padding: 3px 0px 0px;

      width: 18px;
      height: 21px;
    }

    label {
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 150%;
      letter-spacing: -0.01em;
      color: #212429;
    }

    a {
      color: #11a7b6;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
